import { Component, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "home-slider-slide-action-form",
  templateUrl: "./home-slider-slide-action-form.component.html",
  styleUrls: ["./home-slider-slide-action-form.component.scss"],
})
export class HomeSliderSlideActionFormComponent {
  @Input() form: FormGroup;

  imagePositions: Array<Object> = [];
  contentPositions: Array<Object> = [];

  constructor(public fb: FormBuilder, public ft: FormToolsService) {
    this.imagePositions = [
      { value: "left", label: "Izquierda" },
      { value: "right", label: "Derecha" },
      { value: "center", label: "Centro" },
    ];

    this.contentPositions = [
      { value: "top", label: "Arriba" },
      { value: "right", label: "Derecha" },
      { value: "bottom", label: "Abajo" },
      { value: "left", label: "Izquierda" },
      { value: "center", label: "Centro" },
    ];
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/home-slider-slide-action-form/home-slider-slide-action-form.component.ts